// extracted by mini-css-extract-plugin
export var button = "_7l-0";
export var icon = "_7l-1";